import { SheRavenClient } from './ravenClient';
import { SheEnv } from '../../commonv3/utils/envs';

declare const gtag: any;

/**
 * テスト用のGAイベントのテスト用ヘルパー
 * windowオブジェクト内のネームスペースに、送信した全イベントのログを保存する
 * @private
 */
function logGaEvent(
    category: string,
    action: string,
    label?: string,
    value?: number | string,
    fieldOptions: object = {}
) {
    if (!SheEnv.isTest() && !SheEnv.isDevelopment()) {
        return;
    }
    if (typeof window === 'undefined') {
        return;
    }
    const KEY_FOR_GA = '__she_ga_events';
    window[KEY_FOR_GA] = window[KEY_FOR_GA] || [];
    window[KEY_FOR_GA].push({ category, action, label, value, fieldOptions });
}

export const GoogleAnalyticsClient = {
    /**
     * Send the specified event to google analytics
     * @param category: Typically the object that was interacted with (e.g. 'Video')
     * @param action: The type of interaction (e.g. 'play')
     * @param label: Useful for categorizing events (e.g. 'Fall Campaign')
     * @param value: A numeric value associated with the event (e.g. 42)
     * @see https://developers.google.com/analytics/devguides/collection/gtagjs/events#send-events
     */
    sendGaEvent(category: string, action: string, label?: string, value?: number | string, fieldsOptions: object = {}) {
        logGaEvent(category, action, label, value, fieldsOptions);
        if (typeof gtag !== 'undefined') {
            const fields = {
                event_category: category,
                event_label: label,
                value: value,
            };
            gtag('event', action, Object.assign(fields, fieldsOptions));
        } else {
            SheRavenClient.captureException(new Error('sendGaEvent called without ga set up'), {
                category,
                action,
                label,
                value,
            });
        }
    },
};
